import { SVGProps } from "react";

const AsteriskBlue = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="162"
      height="157"
      viewBox="0 0 162 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M31.6536 152.463C35.8393 155.514 40.6988 156.986 45.5229 156.986C52.7829 156.986 59.9477 153.651 64.5588 147.382C64.572 147.369 64.5845 147.355 64.5964 147.341C64.6075 147.326 64.6186 147.311 64.6291 147.297L64.645 147.274C64.6562 147.258 64.6666 147.243 64.677 147.228L80.9939 124.71L97.3107 147.228C97.3267 147.253 97.3434 147.271 97.3594 147.292C97.367 147.302 97.374 147.312 97.3816 147.323C105.067 157.829 119.835 160.143 130.346 152.475C140.869 144.807 143.222 129.981 135.631 119.393L135.614 119.366C135.6 119.344 135.589 119.327 135.572 119.309L119.291 96.7789L145.67 88.1614C158.061 84.1136 164.871 70.6883 160.839 58.2477C156.808 45.8077 143.447 38.9704 131.044 43.0064L104.665 51.5888L104.654 23.7289C104.641 10.6477 94.0352 0 81.0057 0C67.9761 0 57.3703 10.6477 57.3585 23.7408L57.3349 51.5769L30.9561 42.9945C30.9457 42.9945 30.933 42.9922 30.9202 42.9885C30.9036 42.9841 30.8865 42.9774 30.8733 42.9707C18.4939 38.9823 5.18037 45.8196 1.16033 58.2365C-2.85978 70.6527 3.90349 84.0305 16.2355 88.1139C16.2469 88.1174 16.2572 88.1216 16.267 88.1258L16.3104 88.1425L16.3302 88.1495L42.697 96.7671L26.4157 119.298C26.4098 119.309 26.401 119.321 26.3922 119.333C26.3832 119.345 26.3745 119.357 26.3685 119.369C18.7658 129.957 21.1306 144.795 31.6536 152.463Z"
        fill="#4692F8"
      />
    </svg>
  );
};

export default AsteriskBlue;
